import { Bridge, NavBar, BackButton } from '@mc/mc-jsbridge'

export const appNavBar = Bridge.prepared ? new NavBar() : {}

export const initAppNavBar = () => {
  if (appNavBar.init && !appNavBar._init) {
    appNavBar.init()
    const btnBack = new BackButton()
    typeof appNavBar.setButton === 'function' && appNavBar.setButton(1, btnBack)
  }
}
